export default __webpack_public_path__ + "static/media/pomomilk.10003a40.png";